import React from 'react';
import classNames from 'classnames';

type Props = {
  disabled?: boolean,
  outline?: boolean,
  outlineDark?: boolean,
  content: string,
  onClick: Function,
  dataId?: string,
};

function Button(props: Props) {
  const { disabled, outline, outlineDark, content, onClick, dataId } = props;
  const btnClass = classNames({
    disabled,
    'bttn--primary': !outline,
    'bttn-outline bttn-outline--primary': outline,
    'bttn-outline--dark': outlineDark,
  });
  return (
    <button
      type="button"
      className={btnClass}
      onClick={disabled ? undefined : onClick}
      data-automation-id={dataId && dataId}
    >
      <span className="bttn__content">{content}</span>
    </button>
  );
}

Button.defaultProps = {
  disabled: false,
  outline: false,
  outlineDark: false,
  dataId: null,
};

export default Button;
